/* This example requires Tailwind CSS v2.0+ */
import { Fragment , useContext} from 'react'
import { Disclosure} from '@headlessui/react'
import { MoonIcon ,MenuIcon, XIcon , SunIcon} from '@heroicons/react/outline'
import {navigation} from './../../data/navigation'
import {Link , NavLink} from "react-router-dom"
import useDarkMode from "./../../hooks/UseDarkMode"
import { darkModeContext } from '../../App'


function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function Header() {

    const {theme , toggleTheme} = useContext(darkModeContext)

  return (

    <Disclosure as="nav" className="bg-white-800 border-b dark:text-white">
      {({ open }) => (
        <>
          <div className="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8">
            <div className="relative flex items-center justify-between h-16">
              <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
                {/* Mobile menu button*/}
                <Disclosure.Button className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                  <span className="sr-only">Open main menu</span>
                  {open ? (
                    <XIcon className="block h-6 w-6" aria-hidden="true" />
                  ) : (
                    <MenuIcon className="block h-6 w-6" aria-hidden="true" />
                  )}
                </Disclosure.Button>
              </div>
              <div className="flex-1 flex items-center justify-center sm:items-stretch sm:justify-start">
                <div className="flex-shrink-0 flex items-center">
                        <Link
                        to="/"
                        className='text-black-300 hover:bg-gray-700 text-lg hover:text-white px-3 py-2 rounded-md text-sm font-medium'
                      >
                        Abdelmalek
                      </Link>
                </div>
                <div className="hidden sm:block sm:mx-auto">
                  <div className="flex space-x-4">
                    {navigation.map((item) => (
                      <NavLink
                        key={item.name}
                        to={item.href}
                        className={classNames( 'text-black-300 hover:bg-gray-700 hover:text-white',
                          'px-3 py-2 rounded-md text-sm font-medium text-lg'
                        )}
                        aria-current={item.current ? 'page' : undefined}
                      >
                        {item.name}
                      </NavLink>
                    ))}
                  </div>
                </div>
              </div>
              <div className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
                {theme === "light" ? (
                   <button
                   onClick={toggleTheme}
                   type="button"
                   className="border-gray-500 border p-1 rounded-full text-gray-400 hover:text-black hover:border-black"
                 >
                   <span className="sr-only">View notifications</span>
                   <MoonIcon className="block h-6 w-6" aria-hidden="true" />
                 </button>
                ) : (
                  <button
                  onClick={toggleTheme}
                  type="button"
                  className="border-gray-500 border p-1 rounded-full hover:text-white text-gray-400 "
                >
                  <span className="sr-only">View notifications</span>
                  <SunIcon className="block h-6 w-6" aria-hidden="true" />
                </button>
                )}
              </div>
            </div>
          </div>

          <Disclosure.Panel className="sm:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1">
              {navigation.map((item) => (
                <NavLink
                  key={item.name}
                  to={item.href}
                  className={classNames(
                    item.current ? 'bg-gray-900 text-white' : 'text-black-300 hover:bg-gray-700 hover:text-white',
                    'block px-3 py-2 rounded-md text-base font-medium'
                  )}
                  aria-current={item.current ? 'page' : undefined}
                >
                  {item.name}
                </NavLink>
              ))}
            </div>
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  )
}